class MessageAlert extends HTMLElement {
    constructor() {
      super();
    }
  
    showMessage() {
      this.classList.add('alert--active');
      setTimeout(() => {
        this.classList.remove('alert--active');
      }, 3000);
    }
  }
  
  customElements.define('message-alert', MessageAlert);
  
  class CheckoutButton extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    this.form = this.closest('form');

    this.currency = this.dataset.currency;
    this.total = this.dataset.cartTotal;
    this.items;

    this.getCartItems();

    if (this.button && this.form) {
      this.button.addEventListener('click', this.onButtonClick.bind(this));
    }
  }

  getCartItems() {
    const itemsContainer = this.querySelector('[data-cart-items]');

    if (itemsContainer) this.items = JSON.parse(itemsContainer.textContent);
  }

  onButtonClick(event) {

    if (this.currency && this.total && this.items) {
      window.dataLayer = window.dataLayer || []; 
      window.dataLayer.push({
        'event': 'dl_begin_checkout',
        'currency': this.currency,
        'cart_total': this.total, 
        'items': this.items
      });
    }
  }
}

  customElements.define('checkout-button', CheckoutButton);